import React from 'react';
import { useParams } from 'react-router-dom';
import { Button } from 'primereact/button';
import { useLanguage } from '../../../../contexts/LanguageContext';
import useServiceBulletinDetail from '../hooks/useServiceBulletinDetail';
import ServiceBulletinDetailTable from '../components/ServiceBulletinDetailTable';
import BulletinDocuments from '../components/BulletinDocuments';

export default function ServiceBulletinDetail() {
    const { bulletinNo } = useParams();
    const { th } = useLanguage();

    const {
        items,
        totalCount,
        bulletinInfo,
        isLoading,
        lazyParams,
        onPage,
        activeFilters,
        handleFilterChange,
        resetFilters,
        sortField,
        sortOrder,
        onSort,
    } = useServiceBulletinDetail(bulletinNo);

    return (
        <div className="card">
            {/* Header */}
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">
                    {th('serviceBulletinReport.detail.title')} <span className="font-normal text-600 text-xl">#{bulletinNo}</span>
                </h1>
                <Button label={th('common.close')} icon="pi pi-times" className="p-button-outlined" onClick={() => window.close()} />
            </div>
       {/* Bülten Bilgileri */}
            {bulletinInfo && (
                <div className="mb-3 p-3 surface-100 border-round">
                    <div className="flex gap-3">
                        <div style={{ flex: '0 0 auto', minWidth: '130px' }}>
                            <div className="flex align-items-center gap-2 mb-2 text-600">
                                <i className="pi pi-hashtag"></i>
                                <span>{th('serviceBulletinReport.columns.bulletinNumber')}</span>
                            </div>
                            <div className="text-900 font-semibold">{bulletinInfo.qmnum || '-'}</div>
                        </div>
                        <div style={{ flex: '1 1 auto' }}>
                            <div className="flex align-items-center gap-2 mb-2 text-600">
                                <i className="pi pi-tag"></i>
                                <span>{th('serviceBulletinReport.columns.bulletinName')}</span>
                            </div>
                            <div className="text-900 font-semibold">{bulletinInfo.bulletinName || '-'}</div>
                        </div>
                        <div style={{ flex: '1 1 auto' }}>
                            <div className="flex align-items-center gap-2 mb-2 text-600">
                                <i className="pi pi-align-left"></i>
                                <span>{th('serviceBulletinReport.columns.bulletinDescription')}</span>
                            </div>
                            <div className="text-900 font-semibold">{bulletinInfo.bulletinDescription || '-'}</div>
                        </div>
                        <div style={{ flex: '0 0 auto', minWidth: '150px' }}>
                            <div className="flex align-items-center gap-2 mb-2 text-600">
                                <i className="pi pi-info-circle"></i>
                                <span>{th('serviceBulletinReport.columns.shortDescription')}</span>
                            </div>
                            <div className="text-900 font-semibold">{bulletinInfo.kurztext || '-'}</div>
                        </div>
                        <div style={{ flex: '0 0 auto', minWidth: '100px' }}>
                            <div className="flex align-items-center gap-2 mb-2 text-600">
                                <i className="pi pi-file"></i>
                                <span>{th('serviceBulletinReport.detail.documents')}</span>
                            </div>
                            <BulletinDocuments bulletinNo={bulletinNo} />
                        </div>
                    </div>
                </div>
            )}
            {/* Detay Tablosu */}
            <ServiceBulletinDetailTable
                items={items}
                totalCount={totalCount}
                loading={isLoading}
                lazyParams={lazyParams}
                onPage={onPage}
                sortField={sortField}
                sortOrder={sortOrder}
                onSortChange={onSort}
                activeFilters={activeFilters}
                onFiltersChange={handleFilterChange}
                onResetFilters={resetFilters}
            />
        </div>
    );
}